import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="main-footer">
      <p>V-CORP © 2025 - 2026. Todos os direitos reservados.</p>
    </footer>
  );
};

export default Footer;
